// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3wvE7","formContent":"Form_formContent__177Vn","formFooter":"Form_formFooter__1aozF"};